import firebase from 'gatsby-plugin-firebase'

const loadFirebase = () => {
  const lazyDatabase = import('firebase/database')
  const lazyAnalytics = import('firebase/analytics')
  return Promise.all([lazyDatabase, lazyAnalytics])
}

export const submitQuizResult = ({ answers, profile }) => {
  let formattedAnswers = {
    age: answers.age,
    gender: answers.gender,
    relationshipStatus: answers.relationshipStatus,
  }

  Object.keys(answers).forEach(key => {
    if (!Object.keys(formattedAnswers).includes(key)) {
      const value = [answers[key]]
      formattedAnswers[key] = [
        'Strongly disagree',
        'Disagree',
        'Neutral',
        'Agree',
        'Strongly agree'
      ][value]
    }
  })

  return new Promise((resolve, reject) => {
    loadFirebase()
      .then(() => {
        const db = firebase.database()
        const listRef = db.ref('quiz_results')
        const ref = listRef.push()
        ref
          .set({
            profile,
            answers: formattedAnswers
          })
          .then(() => {
            firebase
              .analytics()
              .logEvent('quiz_completed', { quiz_result_id: ref.key })
            
            resolve({ id: ref.key })
          })
          .catch(reject)
      })
  })
}

export const fetchQuizResult = (id) => {
  return new Promise((resolve, reject) => {
    loadFirebase()
      .then(() => {
        const db = firebase.database()
        const ref = db.ref(`quiz_results/${id}`)
        ref
          .once('value')
          .then(snapshot => resolve(snapshot.val()))
          .catch(reject)
      })
  })
}